// ============================================
// 🧭 Pipeline stage names on screen (the server's rule: src/utils/leadStage.js)
// src/utils/stages.js
// ============================================
export const STAGES = ['new', 'contacted', 'qualified', 'converted', 'not_qualified', 'lost'];
export const STAGE_LABELS = { new: 'New', contacted: 'Contacted', qualified: 'Qualified', converted: 'Converted', not_qualified: 'Not qualified', lost: 'Lost' };

// older leads without a stage yet: closest match from the old status
const FROM_STATUS = { pending: 'new', new: 'new', contacted: 'contacted', qualified: 'qualified', converted: 'converted', lost: 'lost' };

export function stageOf(lead) {
  const s = lead?.stage || FROM_STATUS[String(lead?.status || '').toLowerCase()] || 'new';
  return { key: s, label: STAGE_LABELS[s] || s, why: lead?.stageReason || '' };
}

// text colour per stage (calm; only the two ways out stand apart)
export const STAGE_TONE = {
  new: 'text-[#10203A]', contacted: 'text-[#10203A]', qualified: 'text-emerald-800',
  converted: 'text-emerald-800', not_qualified: 'text-gray-600', lost: 'text-orange-800'
};
